import { jsx as L, jsxs as i } from "react/jsx-runtime";
import "react";
var e = (t) => /* @__PURE__ */ i("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...t,
  children: [
    /* @__PURE__ */ L("rect", {
      width: 20,
      height: 20,
      fill: "#F5F5F5"
    }),
    /* @__PURE__ */ L("rect", {
      width: 1876,
      height: 988,
      transform: "translate(-52 -588)",
      fill: "white"
    }),
    /* @__PURE__ */ L("path", {
      d: "M0 0V10V20H20V10V0H0Z",
      fill: "#D80027"
    }),
    /* @__PURE__ */ L("path", {
      d: "M15.2578 8.50781H11.2422L10 4.6875L8.75781 8.50781H4.74219L7.99219 10.8672L6.75 14.6875L10 12.3281L13.25 14.6875L12.0078 10.8672L15.2578 8.50781ZM8.90234 10.5742L9.32031 9.28125H10.6797L11.0977 10.5742L10 11.3711L8.90234 10.5742ZM10.4258 8.50781H9.57031L9.99609 7.19141L10.4258 8.50781ZM11.7578 10.0977L11.4922 9.28516H12.875L11.7578 10.0977ZM8.50781 9.28125L8.24219 10.0938L7.12109 9.28125H8.50781ZM8.22266 12.6641L8.64844 11.3477L9.33984 11.8516L8.22266 12.6641ZM10.6562 11.8516L11.3477 11.3477L11.7734 12.6641L10.6562 11.8516Z",
      fill: "#6DA544"
    })
  ]
});
export {
  e as default
};
